export default "__VITE_ASSET__C$p8Aj57__"